import { Auth } from 'aws-amplify';
import { getItemFromSessionStorage } from './storageUtils'

export const IsLoggedIn = async () => {
    return Auth.currentSession()
        .then((result: any) => {
            if (result.accessToken.jwtToken) {
                return true;
            } else {
                return false;
            }
        })
        .catch(() => { return false });
}
//   // DATE FORMAT END

export const formatDate = (dateVal: any) => {
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    let date = new Date(dateVal).getDay();
    let movingDay: string = new Date(dateVal).getDate().toString()
    let movingDateString: string = movingDay.length === 1 ? "0" + movingDay : movingDay
    let movingMonth = dateVal ? dateVal.getMonth() + 1 : new Date().getMonth();
    let movingYear = dateVal ? dateVal.getFullYear() : new Date().getFullYear();

    return weekday[date] + ", " + movingMonth + "/" + movingDateString + "/" + movingYear

}
export const formateNumber=(value:any)=>{
    return value?Number(value).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}):0.00
}

export const phoneFormat = (phone: string) => {

    if (!phone){
        return "";
    }
        
    const validPhone = phone.replace(/[^\w\s]/gi, '')
    const phoneFormatArray: any = validPhone.match(/(\d{3})(\d{3})(\d{4})/);

    return `(${phoneFormatArray[1]}) ${phoneFormatArray[2]}-${phoneFormatArray[3]}`;
}

export const getStoreValue = (key: string, journeyStoreRef: any, defVal?: any) => {
    if (journeyStoreRef && journeyStoreRef[key])
        return journeyStoreRef[key];
    return defVal;
}

export const getCustomerId = () => {
    if (getItemFromSessionStorage('customerId')) {
        return getItemFromSessionStorage('customerId');
    } else {
        console.error('No customer id found in the app.');
        //either throw an exception or redirect user to some page.
    }
}

// get dailysheetId
export const getDailysheetId = () => {
    if (getItemFromSessionStorage('dailysheetId')) {

        return getItemFromSessionStorage('dailysheetId');
    } else {
        console.error('No dailysheetId found in the app.');
    }

}

export const getRandomNumber = () => {
    return new Date().getTime()
}



export const calculateBase64SignSize = (base64: any) => {
    let size = 0;
    if (base64) {
        const buffer = Buffer.from(base64?.substring(base64?.indexOf(',') + 1));
        size = buffer?.length || 0;
    }

    return size;

}